module.exports = __webpack_public_path__ + "static/media/home11.bfdcfa29.jpg";